export const smallApplianceModelsAllowed = ["FORGE02S6VM","FORGE02CUPS","FORGE02PACK","XPIO13BCBT","G8P1AASSPSS"];
export const customerClassCodeElements =['HOSPITALITY DIRECT NEW CONST','APARTMENT REPLACEMENT DIST','DIRECT PROPERTY MGT REHAB','DPMR','HOME WARRANTY',
    'MULTIFAMILY FOR RENT','MULTIFAMILY FOR SALE','SINGLE FAMILY','SINGLE FAMILY RENOVATION' ];

export const SHIPPING_METHODS_FOR_DELIVERY_CALENDAR = [{
        name: 'SDS Delivery',
        type: 'SDS'
    }, {
        name: 'SDS Will Call',
        type: 'SDS'
    }, {
        name: 'ADC Truckload',
        type: 'ADC'
    }, {
        name: 'ADC LTL',
        type: 'ADC'
    }, {
        name: 'ADC Box Truck',
        type: 'ADC'
    }, {
        name: 'ADC Velocity',
        type: 'ADC'
    }, {
        name: 'MATU-Ocean-Ocean-Full Container',
        type: 'ADC'
    }]


// WEBPACK FOOTER //
// ./src/App/components/common/LookUpTable.js